export class GdsgQueueScanSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "oldestEligibleAtMs",
            "baseName": "oldestEligibleAtMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "ageMs",
            "baseName": "ageMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "freshShards",
            "baseName": "freshShards",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "staleShards",
            "baseName": "staleShards",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unknownShards",
            "baseName": "unknownShards",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "partialShards",
            "baseName": "partialShards",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgQueueScanSummary.attributeTypeMap;
    }
    constructor() {
    }
}
